// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 20px;
}

.input {
    width: 100%;
    padding: 10px;
    margin-top: 15px;
}

.select {
    padding: 10px;
    margin-top: 15px;
}

.form-tag__wrap {
    display: flex;
}

.badge {
    /* width: 100px; */
    display: inline-block;
    padding: 0.25em 0.5em;
    font-size: 1rem;
    font-weight: bold;
    line-height: 1;
    color: #fff;
    text-align: center;
    white-space: nowrap;
    vertical-align: baseline;
    border-radius: 0.25em;
    background-color: #555; /* dark gray */
    border: 1px solid #666; /* dark gray border */
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.2); /* subtle shadow */
    cursor: pointer;
    margin-right: 5px;
    transition: background-color 0.3s;
}

.badge-container {
    margin-top: .8rem;
    display: flex;
    gap: .5rem;
  }
  
  .badge1 {
    padding: .5rem 1rem;
    background-color: gray;
    color: white;
    border-radius: .5rem;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
    transition: background-color 0.3s;
  }
  
  .badge.active {
    background-color: darkgray;
  }

  .badge-container__deco{
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem; /* Space between elements */
  }`, "",{"version":3,"sources":["webpack://./src/components/Form/Form.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,wBAAwB;IACxB,qBAAqB;IACrB,sBAAsB,EAAE,cAAc;IACtC,sBAAsB,EAAE,qBAAqB;IAC7C,sCAAsC,EAAE,kBAAkB;IAC1D,eAAe;IACf,iBAAiB;IACjB,iCAAiC;AACrC;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,sBAAsB;IACtB,YAAY;IACZ,oBAAoB;IACpB,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,iCAAiC;EACnC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,eAAe;IACf,WAAW,EAAE,2BAA2B;EAC1C","sourcesContent":[".form {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    padding: 20px;\n}\n\n.input {\n    width: 100%;\n    padding: 10px;\n    margin-top: 15px;\n}\n\n.select {\n    padding: 10px;\n    margin-top: 15px;\n}\n\n.form-tag__wrap {\n    display: flex;\n}\n\n.badge {\n    /* width: 100px; */\n    display: inline-block;\n    padding: 0.25em 0.5em;\n    font-size: 1rem;\n    font-weight: bold;\n    line-height: 1;\n    color: #fff;\n    text-align: center;\n    white-space: nowrap;\n    vertical-align: baseline;\n    border-radius: 0.25em;\n    background-color: #555; /* dark gray */\n    border: 1px solid #666; /* dark gray border */\n    box-shadow: 0 0 5px rgba(0, 0, 0, 0.2); /* subtle shadow */\n    cursor: pointer;\n    margin-right: 5px;\n    transition: background-color 0.3s;\n}\n\n.badge-container {\n    margin-top: .8rem;\n    display: flex;\n    gap: .5rem;\n  }\n  \n  .badge1 {\n    padding: .5rem 1rem;\n    background-color: gray;\n    color: white;\n    border-radius: .5rem;\n    cursor: pointer;\n    user-select: none;\n    transition: background-color 0.3s;\n  }\n  \n  .badge.active {\n    background-color: darkgray;\n  }\n\n  .badge-container__deco{\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.5rem; /* Space between elements */\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
